import { Resource } from '../shared/resource';

export class LocationType extends Resource {
  id: string;
  name: string;
}
